var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background":"linear-gradient(to right, #030303, #090909)"},attrs:{"dark":""}},[_c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('Navbar')],1),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }